export interface TableCellStyles {
  color?: string;
  width?: number | string;
  maxWidth?: number | string;
  minWidth?: number | string;
  border?: string;
  position?: any;
  bottom?: any;
  right?: any;
  background?: any;
  padding?: any;
  borderRadius?: any;
  height?: any;
  display?: any;
  flexDirection?: any;
  justifyContent?: any;
  backgroundColor?: any;
  alignItems?: any;
  maxHeight?: any;
  marginRight?: any;
  textAlign?: any;
  top?: any;
  left?: any;
  overflow?: any;
  marginBottom?: any;
  minHeight?: any;
  margin?: any;
}

export const UpperBoxSubscriptionListStyles: TableCellStyles = {
  padding: 2,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};
